<template>
  <div class="home pt-4">
    <b-container>
      <b-row>
        <MainLeftBlock :dataSport="dataSport"></MainLeftBlock>
        <MainCenterBlock :dataSport="dataSport"></MainCenterBlock>
        <MainRightBlock :dataSport="dataSport"></MainRightBlock>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import MainLeftBlock from "@/components/blocks/counter_strike/MainLeftBlock.vue";
import MainCenterBlock from "@/components/blocks/counter_strike/MainCenterBlock.vue";
import MainRightBlock from "@/components/blocks/counter_strike/MainRightBlock.vue";

export default {
  name: "counter_strike_home",
  data() {
    return {
      dataSport: {
        textClass: "cs-text-color",
        kindOfSport: "counter-strike",
        sportId: 5,
        link_api: "cs"
      }
    };
  },
  components: {
    MainLeftBlock,
    MainCenterBlock,
    MainRightBlock
  },
  mounted() {},
  metaInfo() {
    return {
      title: this.$t("meta.sports.cs.main.title"),
      titleTemplate: "H2H Liga | %s",
      meta: [
        {
          name: "description",
          content: this.$t("meta.sports.cs.main.description")
        },
        { name: "keywords", content: this.$t("meta.sports.cs.main.keywords") }
      ]
    };
  }
};
</script>
<style>
.game-border-bottom.ehockey_border:not(:last-child):hover {
  border-bottom: 1px solid rgba(70, 206, 255, 0.58) !important;
  transition: all 0.5s;
}
</style>
